<div class="main-content">
    <section class="top-content">
        <div class="top-contents-text">
            <div class="back-link font-inter" (click)="goBack()">
                ← Back to Home
            </div>
            <h1 class="page-title">Terms & Condition</h1>
            <p class="page-subtitle font-inter">
                Your privacy matters to us. Learn how FunFigz protects your data.
            </p>
            <p class="page-meta font-inter">
                Last Updated: January 2024
                <span class="dot">•</span>
                Effective Immediately
            </p>
        </div>
    </section>

    <section class="body-content container">
        <!-- introduction -->
        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="termcondition" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Terms & Conditions Introduction</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    This document details all terms and conditions that apply to an individual or entity buying the products from UDM/FunFigz. In the context of this agreement, “you” refers to the applicant and “we” or “us” refers to UDM Global Solution Private Limited (“UDM”) which is the licensed owner of the brand FunFigz and its associated website ( www.funfigz.com ), it’s mobile website and mobile application (the “Site”). By visiting this Site or by accessing or subscribing to the services provided by Funfigz Solution you are accepting and consenting to these terms and conditions. Please read them carefully. In addition, when you use any current or future UDM’s service or business, you also will be subject to the guidelines, terms and conditions applicable to such service or business.
                    These terms and conditions constitute an electronic record within the meaning of the applicable law. This being an electronic record generated by a computer system does not require any physical or digital signatures.
                </p>
            </div>
        </div>

        <!-- privacy policy -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="privacypolicy" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Privacy Policy</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    Please review our Privacy Policy, which also governs your visit to this Site, to understand our practices.
                </p>
            </div>
        </div>

        <!-- Communications Electronically -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="mail" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Communications Electronically</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    When you visit the Site or send emails to us, you are communicating with us electronically and you consent to receive communications from us electronically. You agree that all agreements, notices, disclosures and other communications that we provide to you electronically satisfy any legal requirement that such communications be in writing.
                </p>
            </div>
        </div>

        <!-- copyright -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="copyright" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Copyright</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    The compilation of all the contents included on this Site, such as text, graphics, logos, button icons, images, audio clips, digital downloads, data compilations, and software, is the exclusive property of UDM and protected by copyright laws of India.
                </p>
            </div>
        </div>

        <!-- Trademark(s) -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="trademark" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Trademark(s)</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    UDM, the UDM logo, the Site, the Site logo and other marks indicated on our Site are trademarks of UDM. Other UDM graphics, logos, page headers, button icons, scripts, and service names are trademarks of UDM. All other trademarks not owned by UDM or the Site that appear on this site are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by UDM.
                </p>
            </div>
        </div>

        <!-- License and site access -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="license" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">License and site access</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    UDM grants you a limited license to access and make personal use of this Site and not to download (other than page caching) or modify it, or any portion of it, except with express written consent of UDM, as may be applicable. This license does not include any resale or commercial use of this site or its contents; any derivative use of this site or its contents; or any use of data mining, robots, or similar data gathering and extraction tools. This site or any portion of this site (including but not limited to any copyrighted material, trademarks, or other proprietary information) may not be reproduced, duplicated, copied, sold, resold, visited, or otherwise exploited for any commercial purpose without express written consent of UDM and / or its affiliates, as may be applicable. You may not frame or utilize framing techniques to enclose any trademark, logo, or other proprietary information (including images, text, page layout, or form) of UDM without their express written consent. You may not use any meta tags or any other “hidden text” utilizing UDM’s name or trademarks without their express written consent. Any unauthorized use terminates the permission or license granted by UDM. You may not use any logo or other proprietary graphic or trademark of UDM or its affiliates as part of the link without their express written permission.
                </p>
            </div>
        </div>

        <!-- Account and Registration Obligation -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="registration" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Account and Registration Obligation</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    You as a shopper have to login, give consent to your current location for accessing the items and then provide your Address and Phone number for placing an order on UDM/FunFigz.
                </p>
            </div>
        </div>

        <!-- Your activity on the UDM/FunFigz site -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="activity" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Your activity on the UDM/FunFigz site</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    Site is not intended for use by children. If you are a minor i.e. under the age of 18 years, you may use the Site only with involvement of a parent or guardian. UDM reserves the right to refuse service, terminate accounts, or remove or edit content in their sole discretion
                </p>

                <p class="paragraph">
                    You must not use the Site in any way that causes, or is likely to cause, the website or access to it to be interrupted, damaged or impaired in any way. You understand that you, and not UDM, are responsible for all electronic communications and content sent from your computer to us and you must use the Site for lawful purposes only and only in accordance with the applicable law of the country.
                </p>

                <div class="rules-container">
                    <span class="rules-title font-poppins">You must not use the Site for any of the following:</span>
                    <ul>
                        <li class="rule">for fraudulent purposes, or in connection with a criminal offence or other unlawful activity;</li>
                        <li class="rule">to send, use or reuse any material that is illegal, offensive, (including but not limited to material that is sexually explicit or which promotes racism, bigotry, hatred or physical harm), abusive, harassing, misleading, indecent, defamatory, disparaging, obscene or menacing;</li>
                        <li class="rule"> or in breach of copyright, trademark, confidentiality, privacy or any other proprietary information or right;</li>
                        <li class="rule">or is otherwise injurious to third parties;</li>
                        <li class="rule">or objectionable or otherwise unlawful in any manner whatsoever;</li>
                        <li class="rule">or which consists of or contains software viruses, political campaigning, commercial solicitation, chain letters, mass mailings or any “spam”;</li>
                        <li class="rule">to cause annoyance, inconvenience or needless anxiety;</li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- pricing -->
        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="price" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Pricing</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    All the products listed on the Site will be sold at Selling Price which is always equal to or lesser than the MRP. The prices mentioned at the time of ordering will be the prices charged on the date of the delivery. Although prices of most of the products do not fluctuate on a daily basis but some of the commodities prices do change on a daily basis. Self-Pickup Orders will be free of Delivery charge if any.
                </p>
            </div>
        </div>

        <!-- Cancellation by Seller/Shopper and Refunds -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="cancel" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Cancellation by Seller/Shopper and Refunds</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    You as a shopper can cancel item(s) or entire order before the order is on the transit for delivery.
                </p>

                <div class="rules-container">
                    <span class="rules-title font-poppins">Your item(s) or order can also be cancelled by the seller under the following circumstances</span>
                    <ol>
                        <li class="rule">The package is damaged in transit.</li>
                        <li class="rule">Delivery is refused by the recipient.</li>
                        <li class="rule">Address given is incorrect.</li>
                        <li class="rule">No recipient was available during delivery.</li>
                        <li class="rule">Sudden out of stock of the items.</li>
                    </ol>
                </div>

                <p class="paragraph">In either case, you as a shopper will get a 100% refund to your registered bank account for the cancelled item(s) or order if you have already made the payment online within 2-5 working days.</p>

            </div>
        </div>

        <!-- Reviews and Rating -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="fullstar" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Reviews and Rating</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    A product's average rating will appear alongside their name in the list. If you're tempted to leave a critical rating, make sure that you've given the seller every chance to resolve the issue first.
                    While you are encouraged to share either positive or critical feedback, yet we have the right to remove feedback that is not directly related to the buying experience or violates one of our guidelines. Your comments should not include the following: <br><br>
                    <strong>Promotional content</strong>: This includes anything of a promotional nature such as comments about or links to other merchants or websites.<br>
                    <strong>Objectionable Content</strong>: Please use helpful and appropriate language.<br>
                    <strong>Personal information or attack</strong>: You should not include personal information and should not include personal attack.
                </p>
            </div>
        </div>

        <!-- Copyright Complaints -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="hammer" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Copyright Complaints</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    UDM respects the intellectual property of others and ensures that your intellectual property is not infringed.
                </p>
            </div>
        </div>

        <!-- Services Description -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="servicedescription" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Services Description</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    UDM attempts to be as accurate as possible. However, UDM does not warrant that descriptions of or other content of this site is accurate, complete, reliable, current, or error-free. Also, your access to the Site may also be occasionally suspended or restricted to allow for repairs, maintenance, or the introduction of new facilities or at any time without prior notice. We will attempt to limit the frequency and duration of any such suspension or restriction. UDM is not responsible for the availability of any third-party sites or resources.
                </p>
            </div>
        </div>

        <!-- Disclaimer of warranties and limitation of liabilities -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="disclaimer" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Disclaimer of warranties and limitation of liabilities</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    This site is provided by UDM on an “as is” and “as available” basis. UDM makes no representations or warranties of any kind, express or implied, as to the operation of this site or the information, content, materials, or products included on this site. you expressly agree that your use of this site is at your sole risk. UDM reserves the right to withdraw or delete any information from this site at any time in its discretion.
                    To the full extent permissible by applicable law, UDM disclaims all warranties, express or implied, including, but not limited to, implied warranties of merchantability and fitness for a particular purpose. UDM does not warrant that this site, its servers, or e-mail sent from UDM are free of viruses or other harmful components. UDM will not be liable for any damages of any kind arising from the use of this site, including, but not limited to direct, indirect, incidental, punitive, and consequential damages
                </p>
            </div>
        </div>

        <!-- Applicable Law -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="applicablelaw" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Applicable Law</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    By visiting this Site, you agree that the laws of India will govern these Terms and Conditions and any dispute of any sort that might arise between you and UDM.
                </p>
            </div>
        </div>

        <!-- Disputes -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="despute" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Disputes</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    Any dispute relating in any way to your visit to this Site shall be submitted to the exclusive jurisdiction of the courts at Bangalore, India.
                </p>
            </div>
        </div>


        <!-- Site Policies, Modification and Severability -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="sitepolicy" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Site Policies, Modification and Severability</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    Please review our other policies on this Site. These policies also govern your visit to the Site. We reserve the right to make changes to our Site, policies, and these Terms and Conditions at any time without any notice. If any of these conditions shall be deemed invalid, void, or for any reason unenforceable, that condition shall be deemed severable and shall not affect the validity and enforceability of any remaining condition.
                </p>
            </div>
        </div>


        <!-- Delivery Policy -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="delivery" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Delivery Policy</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    We will deliver your item within 3-7 days depending on your pincode.
                </p>
            </div>
        </div>


        <!-- Return Policy -->

        <div class="section">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="box" class="icon"></mat-icon>
                </span>
                <p class="title font-poppins">Return Policy</p>
            </div>

            <div class="paragraph-container">
                <p class="paragraph">
                    Items can be returned within 7 days after delivery.
                </p>
            </div>
        </div>

        <div class="section contact">
            <div class="title-container">
                <span class="icon-container">
                    <mat-icon svgIcon="location" class="icon"></mat-icon>
                </span>
                <div class="title-subtitle">
                    <p class="title font-poppins">Contact Information</p>
                    <p class="subtitle">Get in touch with us</p>
                </div>
            </div>

            <div class="contact-info-container">
                <p class="title font-poppins">UDM Global Solution Private Limited</p>

                <div class="contact-info-section">
                    <mat-icon svgIcon="building" class="icon"></mat-icon>
                    <div class="contact-info">
                        <p class="label">Registered Office:</p>
                        <p>#55/3 & 55/4, *th Floor</p>
                        <p>Shilpitha Tech Park</p>
                        <p>Devarabisanahalli, Bellandur</p>
                        <p>Bangalore – 560103</p>
                        <p>Karnataka, India</p>
                    </div>
                </div>

                <div class="contact-info-section">
                    <mat-icon svgIcon="phone" class="icon"></mat-icon>
                    <div class="contact-info">
                        <p class="label">Phone:</p>
                        <p class="value">+91 7338617765</p>
                    </div>
                </div>

                <div class="contact-info-section">
                    <mat-icon svgIcon="email" class="icon"></mat-icon>
                    <div class="contact-info">
                        <p class="label">Email:</p>
                        <p class="value">{{email}}</p>
                    </div>
                </div>

                <div class="separator"></div>

                <div class="support-available">
                    <mat-icon svgIcon="clock" class="icon"></mat-icon>
                    <p> Customer support available Monday to Saturday, 9:00 AM - 6:00 PM IST</p>
                </div>
            </div>

        </div>


        <div class="bottom-content">
            <div class="bottom-text-content">

                <mat-icon svgIcon="activewishlist" class="icon"></mat-icon>

                <h3>Thank You for Trusting FunFigz</h3>

                <p class="font-inter">Your privacy and security are at the heart of everything we do. We're committed to providing you with a safe, transparent, and enjoyable shopping experience. If you have any questions or concerns, please don't hesitate to reach out.</p>

            </div>
        </div>
    </section>
</div>
